import React from 'react';
import { Link } from 'react-router-dom'
import SubLayout from '../../components/Layout/SubLayout'
import strings from "../../components/Language";
import "./wallet.scss"
import _ from 'lodash';

import { IconArrowDown, IconArrowUp, IconSwap } from '../../components/Icons';
import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from '../../components/config/api.js';
import { getToken, storeUserData, getUserData } from '../../components/Util';

import LoaderContext from '../../components/Loader/LoaderContext.js';
import moment from 'moment';
import NativeDateField from '../../components/NativeDateField';
class WalletScreen extends React.Component {

	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			data: [],
			nextPageLink: "",
			prevPageLink: "",
			balance: 0,
			user_data: {},
			active_tab: "usdt",
			startDate: null,
			endDate: null,

		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			this.setState({ access_token: token });
			setTimeout(() => {
				var user_data = getUserData();
				this.setState({ user_data: (user_data && user_data.data) ? user_data.data : {} });
				this.getData(api.usdt_history);
			});
		}
	}

	getData(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var self = this;
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {

			if (ress.data.data && ress.data.data.length > 0) {
				self.setState({
					data: ress.data.data,
					nextPageLink: ress.data.links.next,
					prevPageLink: ress.data.links.prev,
					balance: ress.data.available_usdt
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getNextData(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var API_URL = API;
		if (this.state.startDate && this.state.endDate) {
			API_URL = API + "&start_date=" + (this.state.startDate ? moment(this.state.startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.endDate ? moment(this.state.endDate).format("YYYY-MM-DD") : "");
		}
		var self = this;
		self.setState({
			nextPageLink: "",
			prevPageLink: "",
		});
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {

			if (ress.data.data && ress.data.data.length > 0) {
				self.setState({
					data: [...self.state.data, ...ress.data.data],
					nextPageLink: ress.data.links.next,
					prevPageLink: ress.data.links.prev,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			toast.error(e.message);
			setLoading(false);
		});
	};

	handleNativeRange = (which, value) => {
		const key = which === 'start' ? 'startDate' : 'endDate';
		this.setState({ [key]: value || null }, () => {
			const { startDate, endDate } = this.state;
			if (this.props.onChange) {
				this.props.onChange({ startDate, endDate });
			}
			if (startDate && endDate) {
				const sd = moment(startDate).format('YYYY-MM-DD');
				const ed = moment(endDate).format('YYYY-MM-DD');
				this.getData(`${api.usdt_history}?start_date=${sd}&end_date=${ed}`);
			} else if (!startDate && !endDate) {
				this.getData(api.usdt_history);
			}
		});
	};


	renderBalance(value) {
		// big whole + 2 decimals, remaining 6 decimals muted
		const text = Number(value || 0).toFixed(8);
		const [whole, dec] = text.split('.');
		return (
			<div className="wl-balance-value">
				{whole}.{dec.slice(0, 2)}<span className="wl-balance-dim">{dec.slice(2)}</span>
				<span className="wl-balance-unit">{strings.usdt}</span>
			</div>
		);
	}

	render() {
		const { startDate, endDate } = this.state;
		const actions = [
			{ to: '/deposit', Icon: IconArrowDown, title: strings.deposit },
			{ to: '/transfer', Icon: IconSwap, title: strings.transfer },
			{ to: '/withdrawal', Icon: IconArrowUp, title: strings.withdraw }
		];
		const showFuelAlert = (
			this.state.user_data
			&& (this.state.user_data.credit && this.state.user_data.credit.usdt >= 2 && this.state.user_data.credit.usdt < 10)
			&& (this.state.user_data.status_data && this.state.user_data.status_data.identifier === "active")
		);

		return (
			<SubLayout data={{ "title": strings.wallet }}>
				<div className="wl-page">
					<section className="wl-hero">
						<div className="wl-hero-label">{strings.usdt_balance}</div>
						{this.renderBalance(this.state.balance)}
						<div className="wl-actions">
							{actions.map(({ to, Icon, title }) => (
								<Link key={to} to={to} className="wl-action">
									<span className="wl-action-icon"><Icon size={20} /></span>
									<span className="wl-action-label">{title}</span>
								</Link>
							))}
						</div>
					</section>

					{showFuelAlert ?
						<div className='wl-alert'>{strings.fuel_balance_is_insufficient}</div>
						: null}

					<div className="wl-section-head">
						<h3>{strings.history_record}</h3>
					</div>

					<div className='date-range-native wl-range'>
						<div className='drn-field'>
							<label className='drn-label'>{strings.from_date}</label>
							<NativeDateField value={startDate || ''} max={endDate || undefined}
								onChange={(e) => this.handleNativeRange('start', e.target.value)} />
						</div>
						<div className='drn-field'>
							<label className='drn-label'>{strings.to_date}</label>
							<NativeDateField value={endDate || ''} min={startDate || undefined}
								onChange={(e) => this.handleNativeRange('end', e.target.value)} />
						</div>
					</div>

					{this.state.data && this.state.data.length > 0 ?
						<>
							<ul className='wl-list'>
								{this.state.data.map((item, i) => {
									const out = Number(item.amount) < 0;
									return (
										<li key={item.id || i} className='wl-row'>
											<span className={'wl-row-icon ' + (out ? 'is-out' : 'is-in')}>
												{out ? <IconArrowUp size={18} /> : <IconArrowDown size={18} />}
											</span>
											<span className='wl-row-main'>
												<span className='wl-row-title'>{item.description || item.title || '-'}</span>
												<span className='wl-row-sub'>{item.created_at_ ? moment(item.created_at).format("YYYY-MM-DD HH:mm:ss") : '-'}</span>
											</span>
											<span className={'wl-row-amount ' + (out ? 'is-out' : 'is-in')}>
												{out ? '' : '+'}{Number(item.amount).toFixed(8)}
											</span>
										</li>
									);
								})}
							</ul>
							{this.state.nextPageLink ?
								<button type="button" className='m-btn m-btn-ghost wl-load-more' onClick={() => this.getNextData(this.state.nextPageLink)}>
									{strings.Load_More}
								</button>
								: null}
						</>
						: <div className='wl-empty'>{strings.no_records_found}</div>}
				</div>
			</SubLayout >
		);
	}
}

export default WalletScreen;
